import ActionTypes from '../constants/ActionTypes';

/* Events */
export const fetchInvoicesElectricityRequested = (currentMonth) => ({
  type: ActionTypes.INVOICES_ELECTRICITY_FETCH_REQUESTED,
  payload: {
    currentMonth,
  },
});

export const fetchInvoicesElectricitySucceeded = (data) => ({
  type: ActionTypes.INVOICES_ELECTRICITY_FETCH_SUCCEEDED,
  payload: {
    data,
  },
});

export const fetchInvoicesElectricityFailed = (error) => ({
  type: ActionTypes.INVOICES_ELECTRICITY_FETCH_FAILED,
  payload: {
    error,
  },
});

export const fetchInvoicesGasRequested = (currentMonth) => ({
  type: ActionTypes.INVOICES_GAS_FETCH_REQUESTED,
  payload: {
    currentMonth,
  },
});

export const fetchInvoicesGasSucceeded = (data) => ({
  type: ActionTypes.INVOICES_GAS_FETCH_SUCCEEDED,
  payload: {
    data,
  },
});

export const fetchInvoicesGasFailed = (error) => ({
  type: ActionTypes.INVOICES_GAS_FETCH_FAILED,
  payload: {
    error,
  },
});

export const fetchInvoicesWaterRequested = (currentMonth) => ({
  type: ActionTypes.INVOICES_WATER_FETCH_REQUESTED,
  payload: {
    currentMonth,
  },
});

export const fetchInvoicesWaterSucceeded = (data) => ({
  type: ActionTypes.INVOICES_WATER_FETCH_SUCCEEDED,
  payload: {
    data,
  },
});

export const fetchInvoicesWaterFailed = (error) => ({
  type: ActionTypes.INVOICES_WATER_FETCH_FAILED,
  payload: {
    error,
  },
});
